module.exports = __webpack_public_path__ + "img/3.74f53814.svg";